import {
  Row,
  Col,
  Card,
  Form,
  Button,
  FloatingLabel,
} from 'react-bootstrap';

import CompanySelect from '../CompanySelect';
import './Form.css';

const Forms = ({
  unit,
  server,
  onSubmit,
  fieldChange,
  permission,
  theme,
  loading
}) => {

  const handleCompanySelect = (companyId, companyData) => {
    // Simula um evento para manter compatibilidade com fieldChange
    const fakeEvent = {
      target: { value: companyId || '' },
      persist: () => {}
    };
    fieldChange(fakeEvent, 'company_id', companyId || '');
  };

  return (
    <Card className='mb-3 mt-3 server-form-container'>
      <Card.Header>
        <h5 className={`mt-2 mb-2 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}>
          Dados do Servidor
        </h5>
      </Card.Header>
      <Card.Body>
        <Form>
          {/* Seção de Informações Básicas */}
          <h6 className={`text-muted mb-3 border-bottom pb-2 ${theme === 'dark' ? 'text-light border-secondary' : ''}`}>
            Informações Básicas
          </h6>
          <Row className="g-2">
            <Col md>
              <FloatingLabel controlId="floatingSerial" label="Serial" className="mb-3">
                <Form.Control
                  type="text"
                  name="serial"
                  placeholder="Serial"
                  value={server?.serial || '--'}
                  onChange={(e) => fieldChange(e, 'serial', e.target.value)}
                  disabled={true}
                />
              </FloatingLabel>
            </Col>
            <Col md>
              <FloatingLabel controlId="floatingIP" label="IP" className="mb-3">
                <Form.Control
                  type="text"
                  name="ip"
                  placeholder="IP"
                  value={server?.ip || ''}
                  onChange={(e) => fieldChange(e, 'ip', e.target.value)}
                  disabled={!permission}
                />
              </FloatingLabel>
            </Col>
          </Row>

          {/* Seção de Empresa */}
          <h6 className={`text-muted mb-3 border-bottom pb-2 ${theme === 'dark' ? 'text-light border-secondary' : ''}`}>
            Empresa
          </h6>
          <Row className="mb-3 g-2">
            <Col md>
              <CompanySelect
                label="Selecionar Empresa"
                options={unit || []}
                selectedValue={server?.company_id}
                onSelectionChange={handleCompanySelect}
                disabled={!permission || loading}
                placeholder="Buscar empresa..."
              />
            </Col>
          </Row> 

          {/* Seção de Datas */}
          <h6 className={`text-muted mb-3 border-bottom pb-2 ${theme === 'dark' ? 'text-light border-secondary' : ''}`}>
            Informações de Sistema
          </h6>
          <Row className="g-2">
            <Col md>
              <FloatingLabel controlId="floatingCreatedAt" label="Criado em" className="mb-3">
                <Form.Control
                  type="text"
                  name="createdAt"
                  placeholder="Criado em"
                  value={server?.createdAt ? new Date(server.createdAt).toLocaleString('pt-BR') : '--'}
                  disabled
                />
              </FloatingLabel>
            </Col>
            <Col md>
              <FloatingLabel controlId="floatingUpdatedAt" label="Atualizado em" className="mb-3">
                <Form.Control
                  type="text"
                  name="updatedAt"
                  placeholder="Atualizado em"
                  value={server?.updatedAt ? new Date(server.updatedAt).toLocaleString('pt-BR') : '--'}
                  disabled
                />
              </FloatingLabel>
            </Col>
          </Row>

          <Row className='g-2'>
            <Col xs="auto">
              <Button
                className='mb-3'
                disabled={!permission || loading}
                onClick={() => onSubmit()}
                variant="success"
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Salvando...
                  </>
                ) : (
                  'Salvar'
                )}
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default Forms;
